// Smoothly bring the calendar into view on mobile once it (or its time slots) appears — anchored on
// `.calendar__content` — so the customer lands on the calendar instead of having to scroll down to
// it. Mobile only (below the `md` breakpoint); on desktop the calendar sits inline beside the form.
export function scrollToCalendar() {
  if (!window.matchMedia('(max-width: 639px)').matches) return;

  // Wait a frame for the reveal / collapse to lay out, then anchor on the calendar.
  requestAnimationFrame(() => {
    const target = document.querySelector('.calendar__content');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
